module.exports = __webpack_public_path__ + "img/pain-spot-4.bcc7fd22.svg";